import axios from "axios";

const request = axios.create({
  baseURL: 'https://youtube.googleapis.com/youtube/v3',
  params: {
    //key: "AIzaSyCmwBvjqe7iClfDz9Xj8ryJrVTK4qyD_Z8"
    key: "AIzaSyBBJXTQjuE_vQPc007O9MlEGW1y5PFwMO0"
    //Key: AIzaSyCSYutA3-livo8N1IlB0zNV0ebFx5sNfG0
    //Key: AIzaSyDF43yKUR2ZcIaVgvs9RnYTJRCvMtraNNQ
    //key: process.env.REACT_APP_YT_API_KEY
  }
})

export default request